import SelectVertical from './SelectVertical';

export default SelectVertical;